var dealerModelService = function (apiService, $q) {

    var DealerModel = function () {
        this._data = {};
    };

    DealerModel.prototype.resetModel = function () {
        this._data = {};
    };

    DealerModel.prototype.resolveDealer = function () {
        var deferred = $q.defer();
        if (this._data.dealer) deferred.resolve(this._data.dealer);
        else {
            // get catalog
            apiService.getCatalog()
                .then(function (catalog) {
                    return catalog.getDealer();
                }.bind(this))
                .then(function (dealer) {
                    this._data.dealer = dealer;
                    deferred.resolve(dealer);
                }.bind(this))
                .catch(function (err) {
                    deferred.reject(err);
                });
        }
        return deferred.promise;
    };

    var _services;
    var _department;

    DealerModel.prototype.resolveDepartment = function (services) {
        if (_department && _.eq(services, _services)) return $q.when(_department);
        return this.resolveDealer()
            .then(function (dealer) {
                return dealer.getDepartment(services);
            })
            .then(function (d) {
                _department = d;
                _services = services;
                return d;
            });
    };

    DealerModel.prototype.getAdvisers = function (services) {
        return this.resolveDepartment(services).then(function (department) {
            return department.getAdvisers();
        });
    };

    // DealerModel.prototype.getDepartment = function (startTime, endTime) {
    //     return this.resolveDealer().then(function (dealer) {
    //         return dealer.getAvailableTime(this.getCurrentDepartmentId(), startTime, endTime);
    //     }.bind(this)).then(function (data) {
    //         return data.getDepartment();
    //     });
    // };

    DealerModel.prototype.setCurrentDepartmentId = function (value) {
        this._data.currentDepartmentId = value;
    };

    DealerModel.prototype.getCurrentDepartmentId = function () {
        return this._data.currentDepartmentId;
    };

    //check if dealer have available time.
    DealerModel.prototype.checkAvailableTime = function () {

        // TODO: change the logic after completion BRD
        return $q.when(true);

        //ToDo probably need to get time range from server side
        var startDate = moment();
        var endDate = moment().add(5, 'days');

        return this.resolveDealer()
            .then(function (dealer) {
                return dealer.getAvailableTime(startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"));
            })
            .then(function (times) {
                var hasSlot = _.find(times.segments, {available: true});
                return !!hasSlot;
            })
            .catch(function (err) {
                return $q.reject(err);
            });
    };
    return new DealerModel();
};
dealerModelService.$inject = ['apiService', '$q'];

module.exports = dealerModelService;
